module.exports = __webpack_public_path__ + "img/Feature.fe9b0144.png";